import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import BrandPriorities from './BrandPriorities';

/**
 * Blocking Brand & Priorities modal. Shown to clients on an active core SEO
 * plan who haven't submitted yet. Re-pops each login until submitted.
 */
export default function BrandPrioritiesModal({ firmId, onSubmitted, onSkip }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return createPortal(
    <div className="fixed inset-0 z-[1100] flex items-start justify-center p-4 overflow-y-auto bg-slate-900/70 backdrop-blur-sm" role="dialog" aria-modal="true" data-testid="brand-priorities-modal">
      <div className="relative w-full max-w-2xl my-6 bg-white rounded-3xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-violet-600 to-indigo-600 px-6 sm:px-8 py-6 text-white">
          <div className="flex items-center gap-2 mb-1">
            <Sparkles className="w-5 h-5" />
            <span className="text-xs font-semibold uppercase tracking-wider text-violet-100">Let’s set you up</span>
          </div>
          <h2 className="text-2xl font-bold" style={{ fontFamily: 'Outfit' }}>Tell us about your brand &amp; priorities</h2>
          <p className="text-sm text-violet-100 mt-1">
            This helps your account manager tailor everything to your firm. All fields are optional — share what you can.
          </p>
        </div>
        {/* Body */}
        <div className="px-6 sm:px-8 py-6 max-h-[70vh] overflow-y-auto">
          <BrandPriorities firmId={firmId} variant="modal" onSubmitted={onSubmitted} onSkip={onSkip} />
        </div>
      </div>
    </div>,
    document.body
  );
}
